import { toast } from "@/hooks/use-toast";
import { Colis, ColisPayload, ProductPayload } from "@/interfaces/Return";

export const checkColis = (
  colisCode: string,
  colis: Colis[],
  validColis: Colis[]
) => {
  const colis_ = colis?.find((colis) => colis.colisCode === colisCode);
  if (!colis_) {
    toast({
      title: "Code colis invalide",
      description: "Ce colis n'existe pas dans la demande",
      variant: "destructive",
    });
    return;
  } else if (validColis.includes(colis_)) {
    toast({
      title: "Colis déjà scanné",
      variant: "destructive",
    });
    return;
  } else if (colis_) {
    toast({
      title: "Colis ajouté avec succès",
      variant: "success",
    });
    return colis_;
  }
};

export const createCanceledReturnReceptionPayload = (
  returnNumber: string,
  colisList: Colis[]
) => {
  const transformedColis: ColisPayload[] = colisList.map((colis) => {
    const products: ProductPayload[] = colis.articles.map((article) => ({
      productId: article.productId,
      ean: article.genCode,
      qte: article.quantity || 1,
    }));
    return {
      colisId: colis.colisId,
      colisCode: colis.colisCode,
      products,
    };
  });

  return {
    numTournee: returnNumber,
    colis: transformedColis,
  };
};
